import { Column } from "../../../../../components/TableDataGridV2/types";
import { IDataListaRecebimentosBaixas } from "../../../../../types/api/financeiro/pesquisar-recebimentos-baixa";


export const colunasRecebimentoBaixas: Column<IDataListaRecebimentosBaixas>[] = [
    {
        id: 'data_movimento',
        label: 'Data movimento',
        type: "date",
        numeric: false,
        sortable: true,
        minWidth: 120,
    },
    {
        id: 'data_emissao',
        label: 'Emissão',
        type: "date",
        numeric: false,
        sortable: false,
        minWidth: 120,
    },
    {
        id: 'data_vencimento',
        label: 'Vencimento',
        type: "date",
        numeric: false,
        filter: false,
        sortable: false,
        minWidth: 120,
    },
    {
        id: 'tipo_publico',
        label: 'Público',
        type: "text",
        numeric: false,
        filter: false,
        sortable: false,
        minWidth: 100,
    },
    {
        id: 'codigo_publico',
        label: 'Código',
        type: "text",
        numeric: false,
        filter: false,
        sortable: false,
        minWidth: 100,
    },
    {
        id: 'nome_publico',
        label: 'Nome',
        type: "text",
        numeric: false,
        filter: false,
        sortable: false,
        minWidth: 100,
    },
    {
        id: 'saldo_principal',
        label: 'Saldo',
        type: "monetary",
        numeric: true,
        filter: false,
        sortable: false,
        minWidth: 100,
    },
    {
        id: 'valor_juros',
        label: 'Juros',
        type: "monetary",
        numeric: true,
        filter: false,
        sortable: false,
        minWidth: 100,
    },
    {
        id: 'valor_multa',
        label: 'Multa',
        type: "monetary",
        numeric: true,
        filter: false,
        sortable: false,
        minWidth: 100,
    },
    {
        id: 'valor_desconto',
        label: 'Desconto',
        type: "monetary",
        numeric: true,
        filter: false,
        sortable: false,
        minWidth: 100,
    },
    {
        id: 'valor_total',
        label: 'Total',
        type: "monetary",
        numeric: true,
        filter: false,
        sortable: false,
        minWidth: 100,
    },
    {
        id: 'correcao_monetaria',
        label: 'Correção Monetária',
        type: "monetary",
        numeric: true,
        filter: false,
        sortable: false,
        minWidth: 100,
    },
    {
        id: 'tipo_baixa',
        label: 'Tipo de Baixa',
        type: "text",
        numeric: false,
        filter: false,
        sortable: false,
        minWidth: 150,
    },
    {
        id: 'data_recebimento',
        label: 'Data recebimento',
        type: "date",
        numeric: false,
        filter: false,
        sortable: false,
        minWidth: 120,
    },
    {
        id: 'departamento',
        label: 'Departamento',
        type: "text",
        numeric: false,
        filter: false,
        sortable: false,
        minWidth: 150,
    },
    {
        id: 'funcao',
        label: 'Função',
        type: "text",
        numeric: false,
        filter: false,
        sortable: false,
        minWidth: 150,
    },

];
